import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import SettingsHome from "./components/SettingsHome";

const Settings = () => {
  return (
    <>
      <Sidebar />

      <MainSection>
        <SectionHeader title="Settings" />
        <SettingsHome />
      </MainSection>
    </>
  );
};

export default Settings;
